import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './locales/i18nData';
import storage from './lib/storage';
import { getItem } from './lib/database';

const config = getItem('APP_CONFIG');
const locale = config?.locale;
i18n
    .use(initReactI18next)
    .init({

        resources: {
            vi: {
                translation: translations.vi
            },
            en: {
                translation: translations.en
            },
            ja: {
                translation: translations.ja
            },
            zh: {
                translation: translations.zh
            },
            ko: {
                translation: translations.ko
            },
            th: {
                translation: translations.th
            },
            km: {
                translation: translations.km
            },
            id: {
                translation: translations.id
            },
            lo: {
                translation: translations.lo
            }
        },
        lng: locale,
        debug: true,
        fallbackLng: 'vi',
        interpolation: {
            escapeValue: false,
        },
    });


export default i18n;
